import { createSlice } from "@reduxjs/toolkit";

export const businessSlice = createSlice({
    name: "businesses",
    initialState: {},
    reducers: {
        loadBusinesses: (state: any, action: any) => {
            state.value = action.payload;
        },
        addBusiness: (state: any, action: any) => {
            state.value.push(action.payload)
        }
    }
});

export const {
    loadBusinesses,
    addBusiness
} = businessSlice.actions;

export default businessSlice.reducer;